import { concat } from 'rxjs'
import { flatMap, switchMap } from 'rxjs/operators'
import { stow } from '@zambezi/caballo-vivo'
import createHelpNowChat$ from '@apiEnabler/ob-common/lib/help-now-chat'
import serviceUnavailableCheck$ from '@apiEnabler/ob-common/lib/service-unavailable-check'
import { initialData$ } from './customer'
import { brand$ } from './brand'
import { rootPath$ } from './navigation'
import { isStaffMember$, employee$ } from './staff'

const bootstrap$ = concat(
  brand$.pipe(stow('brand')),
  rootPath$.pipe(stow('rootPath')),
  isStaffMember$.pipe(
    switchMap(isStaffMember =>
      isStaffMember ? employee$ : brand$.pipe(flatMap(createHelpNowChat$))
    )
  ),
  serviceUnavailableCheck$,
  initialData$
)

export default bootstrap$
